import { Empresa, IEmpresa } from "./empresa.model";
import { Encuesta, IEncuesta } from "./encuesta.model";
import { IPaso, Paso } from "./paso.model";

export interface IEncuestaCliente {
  idEncuestaCliente: string;
  idEmpresa: string;
  idEncuesta: string;
  sucursal: string;
  idPaso: string;
  nombreCliente: string;
  apellidoPaternoCliente: string;
  apellidoMaternoCliente: string;
  enviado: boolean;
  enCurso: boolean;
  progreso: number;
  contestado: boolean;
  empresa?: IEmpresa;
  encuesta?: IEncuesta;
  paso?: IPaso;
}

export class EncuestaCliente implements IEncuestaCliente {
  idEncuestaCliente: string;
  idEmpresa: string;
  idEncuesta: string;
  sucursal: string;
  idPaso: string;
  nombreCliente: string;
  apellidoPaternoCliente: string;
  apellidoMaternoCliente: string;
  enviado: boolean;
  enCurso: boolean;
  contestado: boolean;
  progreso: number;
  empresa?: Empresa;
  encuesta?: Encuesta;
  paso?: Paso;

  constructor(model: IEncuestaCliente) {
    this.idEncuestaCliente = model.idEncuestaCliente;
    this.idEmpresa = model.idEmpresa;
    this.idEncuesta = model.idEncuesta;
    this.sucursal = model.sucursal;
    this.idPaso = model.idPaso;
    this.nombreCliente = model.nombreCliente;
    this.apellidoPaternoCliente = model.apellidoPaternoCliente;
    this.apellidoMaternoCliente = model.apellidoMaternoCliente;
    this.enviado = model.enviado;
    this.enCurso = model.enCurso;
    this.contestado = model.contestado;
    this.progreso = model.progreso;
    this.empresa = model.empresa 
      ? new Empresa(
          model.empresa
        ) 
      : undefined;
    this.encuesta = model.encuesta
      ? new Encuesta(model.encuesta)
      : undefined;
    this.paso = model.paso
      ? new Paso(model.paso)
      : undefined;
  }
}
